import { createAction, props } from '@ngrx/store';
import { PdvSettingsModel } from 'src/app/models/pdv-settings.model';
import { CompanyModel } from 'src/app/models/company.model';
import { EventModel } from 'src/app/models/event.model';

export const PDV_FEATURE = 'pdv';
export const LOAD_PDV = '[Pdv] Load Pdv';
export const LOAD_PDV_SUCCESS = '[Pdv] Load Pdv Success';

export const loadPdv = createAction(LOAD_PDV);

export const loadPdvSuccess = createAction(
  LOAD_PDV_SUCCESS,
  props<{
    settings: PdvSettingsModel;
    company: CompanyModel;
    events: EventModel[];
  }>()
);
